import { css } from 'lit';

export const styles = css `
  :host {
    --u-elevation-level: var(--u-snackbar-elevation-level, 3);
    --_snackbar-margin: var(--u-snackbar-margin, var(--u-spacing-medium, 16px));
    position: fixed;
    inset-inline: 0;
    inset-block-end: 0;
    padding: var(--_snackbar-margin);
    z-index: var(--u-snackbar-z-index, 1070);
    display: flex;
    justify-content: center;
    pointer-events: none;
  }

  .container {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-wrap: wrap;
    min-height: var(--u-snackbar-height, 48px);
    background-color: var(--u-snackbar-container-color, var(--u-color-inverse-surface, rgb(50, 47, 53)));
    border-radius: var(--u-snackbar-shape, var(--u-shape-corner-extra-small, 4px));
    animation-name: snackbar-fade-in;
    animation-duration: 450ms;
    animation-timing-function: cubic-bezier(0.19, 1, 0.22, 1);
    animation-fill-mode: forwards;
    min-width: var(--u-snackbar-min-width, 100%);
    max-width: var(--u-snackbar-max-width, 100%);
    pointer-events: auto;
  }
  .container.dismiss {
    animation-name: snackbar-fade-out;
  }

  u-button {
    color: var(--u-color-inverse-primary, );
    margin: var(--u-snackbar-action-margin, var(--u-spacing-extra-small, 4px));
  }

  u-icon-button {
    color: var(--u-color-on-inverse-surface, rgb(245, 239, 247));
    margin-inline: var(--u-snackbar-close-button-margin, var(--u-spacing-extra-small, 4px));
  }

  .message-container {
    flex: 1 1 auto;
    overflow: hidden;
    color: var(--u-snackbar-message-color, var(--u-color-on-inverse-surface, rgb(245, 239, 247)));
    padding: var(--u-snackbar-text-margin, var(--u-spacing-medium, 16px));
    line-height: 18px;
  }

  .message {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  @media (min-width: 840px) {
    :host {
      --_snackbar-margin: var(--u-snackbar-margin, var(--u-spacing-large, 24px));
    }
    .container {
      min-width: var(--u-snackbar-min-width, 344px);
    }
  }
  @keyframes snackbar-fade-in {
    0% {
      opacity: 0;
      transform: scale3d(0.5, 0.5, 1);
    }
    100% {
      opacity: 1;
      transform: scale3d(1, 1, 1);
    }
  }
  @keyframes snackbar-fade-out {
    0% {
      opacity: 1;
      transform: scale3d(1, 1, 1);
    }
    100% {
      opacity: 0;
      transform: scale3d(0.5, 0.5, 1);
    }
  }
`;
